import { render, staticRenderFns } from "./superannuation-instance-selection.vue?vue&type=template&id=5186a352"
import script from "./superannuation-instance-selection.vue?vue&type=script&lang=js"
export * from "./superannuation-instance-selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports